import { Card } from '@repo/shadcn';

import { CsvExportIcon, PdfExportIcon } from '@components/icons';
import { HeaderBreadcrumb } from '@components/ui';
import { DataTable } from '@components/ui/data.table/data-table';
import PaginationComponent from '@components/ui/pagination';

import { DateRangePickerUrlFilter } from '@/components/ui/search-filter';
import { DEFAULT_PAGE_LIMIT } from '@/constants';
import { OrderHeadingActions } from '@/modules/sales/order-list/order-heading-action.component';
import { orderListColumns } from '@/modules/sales/order-list/order-list.column';
import { useOrderList } from '@/modules/sales/order-list/order-list.hook';
import { jsonToCsv } from '@/utils/json-to-csv.util';
import { mapOrderListToCsvExport } from '@/utils/mappers';

import { SalesSummary } from './sales-summary';

export const ReportSale = () => {
    const { data, isLoading, page, setCurrentPage } = useOrderList({});

    const handleExportToCSV = () => {
        jsonToCsv(
            mapOrderListToCsvExport(data?.data || []),
            'sales_report.csv',
        );
    };

    const handleExportToPdf = () => {
        // Implement PDF export functionality here
        alert('Pdf export is not implemented yet.');
    };

    return (
        <Card className={'space-y-4 p-4'}>
            <div className={'flex items-start justify-between'}>
                <HeaderBreadcrumb
                    showHomeLink={true}
                    items={[{ label: 'Sales Report' }]}
                />
                <div className={'flex items-center gap-4'}>
                    <DateRangePickerUrlFilter />

                    <button
                        type={'button'}
                        className={'scale-[1.2]'}
                        onClick={handleExportToPdf}
                    >
                        <PdfExportIcon />
                    </button>
                    <button
                        type={'button'}
                        className={''}
                        onClick={handleExportToCSV}
                    >
                        <CsvExportIcon />
                    </button>
                </div>
            </div>

            <div>
                <h2 className={'text-xl font-medium'}>Sales Report</h2>
            </div>

            <div className={'flex flex-wrap'}>
                <OrderHeadingActions></OrderHeadingActions>
            </div>

            <SalesSummary />
            <Card>
                <DataTable
                    isLoading={isLoading}
                    data={data?.data || []}
                    columns={orderListColumns}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items || 0}
                    itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                    initialPage={page}
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </Card>
        </Card>
    );
};

ReportSale.displayName = 'ReportSale';
